import AlertIcon from "./AlertIcon";
import { useTranslation } from "react-i18next";

function Alert({title, children}) {
  const { t } = useTranslation();
    return (
        <div
          className="bg-modern-warningLight border-2 border-modern-warning text-sm text-modern-textDark rounded-lg p-4"
          role="alert"
        >
          <div className="flex">
            <div className="flex-shrink-0">
              <AlertIcon />
            </div>
            <div className="ms-4">
              <h3 className="text-base font-semibold">
                {t(title)}
              </h3>
              <div className="mt-1 leading-6 text-base text-modern-textMedium leading-6">
                {children}
              </div>
            </div>
          </div>
        </div>
    )
}

export default Alert;